/* eslint-disable camelcase */
import fetch from "@lib/fetch";

import { reactQueryFetcherAdapter } from "../reactQueryFetcherAdapters";
import { userInfoCacheKey } from "./constants";
import type { GetUserInfoByIdentifierParams, UserInfoResponse } from "./types";

/**
 * Fetch user info by user identifier, which could be either the userId or a query (e.g. jon@braze.com)
 *
 * @param user_identifier unique identifier for user OR query that helps search for user
 * @param app_group_id unique identifier for app group
 * @param search_test_user_names boolean indicating whether we should include user names when searching for value of 'userIdentifier'
 * @param check_orphaned_users boolean indicating whether we should check for orphaned users
 * @returns object containing user info, if found
 */
export const getUserInfoByIdentifier = reactQueryFetcherAdapter(
  userInfoCacheKey,
  async (signal, { user_identifier, ...params }: GetUserInfoByIdentifierParams): Promise<UserInfoResponse> => {
    return fetch(`/apps/user_info/${encodeURIComponent(user_identifier)}`, "GET", params, { signal });
  }
);
